import React from 'react'
import PropTypes from 'prop-types'
import { constants, links } from 'common/helpers'

import NeedDataModal from '../NeedDataModal/NeedDataModal'

import messages from './messages'


const NeedSubscriptionModal = ({ name, data: { item, link, isNotSubscribed } }) => {

  messages.buttonTitle = isNotSubscribed
    ? messages.subscribeButton
    : messages.resubscribeButton

  return (
    <NeedDataModal {...{ name, messages, item, link }} />
  )
}

NeedSubscriptionModal.propTypes = {
  name: PropTypes.string,
  data: PropTypes.shape({
    item: PropTypes.object.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
}

NeedSubscriptionModal.defaultProps = {
  name: constants.modals.premiumProducts.NeedSubscription,
}


export default NeedSubscriptionModal
